
  import { mapState } from 'vuex'
  export default {
    name: 'MaintenanceComponent',
    props: {
      theme: {
        type: String,
        default: 'theme-2'
      }
    },
    data: () => ({
      dialog: false,
      maintenance: {}
    }),
    computed: {
      ...mapState({
        operationSetting: state => state.settings.operationSetting
      })
    },
    watch: {
      operationSetting(value) {
        if (value.website_maintenance) {
          this.dialog = value.website_maintenance?.status
          this.maintenance.description = value.website_maintenance?.description
        }
      }
    },
    mounted() {
      if (this.operationSetting.website_maintenance) {
        this.dialog = this.operationSetting.website_maintenance?.status
        this.maintenance.description = this.operationSetting.website_maintenance?.description
      }
    }
  }
